<div
    class="footer-area text-center bg-white border-top-radius box-shadow"
    [class.card-borderd-theme]="themeService.isCardBorder()"
    [class.component-dark-theme]="themeService.isDark()"
    [class.card-border-radius]="themeService.isCardBorderRadius()"
>
    <p>
        <a
            href="https://www.webstylio.com/"
            class="fw-semibold"
            target="_blank"
        >
            Crizac Ltd
        </a>
        © 2010-2025 All Rights Reserved.
    </p>
</div>
